






















import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Pagination } from "ant-design-vue";
import Crumbs from "@/components/Crumbs/index.vue";

@Component({
  name: "Link",
  components: {
    Crumbs,
    APagination: Pagination
  }
})
export default class Notice extends Base {
  private dataSource: any[] = [];

  private created() {
    this._created();
    this.getLinkList();
  }

  private async getLinkList() {
    const res = await this.$api.IntservLink();
    if (res && res.code === 200) {
      this.dataSource = res.data;
    }
    return res;
  }
}
